//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LineAnalysis from '@views/decision/chart/lineAnalysis.vue';
import SameAnalysis from '@views/decision/chart/sameAnalysis.vue';
import ChainAnalysis from '@views/decision/chart/chainAnalysis.vue';
import St21Cn2061ReportDate from '@views/decision/report/St21Cn2061ReportDate.vue';
export default {
  name: 'realTimeData',
  data: function data() {
    return {
      reportType: '1'
    };
  },
  components: {
    St21Cn2061ReportDate: St21Cn2061ReportDate,
    ChainAnalysis: ChainAnalysis,
    SameAnalysis: SameAnalysis,
    LineAnalysis: LineAnalysis
  },
  props: ['siteId', 'selectType', 'showSiteTree'],
  created: function created() {},
  watch: {},
  methods: {}
};